export default {
  setProperty(state, { payload, property }) {
    state[property] = payload;
  },

  setCurrentSelected(state, { property, payload }) {
    state.currentSelected[property] = payload;
  },
};
